module.exports = __webpack_public_path__ + "static/media/person-running-with-two-shadows.1be8c3ce.svg";